import { useSelector } from "react-redux";

const hmacSha256Hex = async (message, secret) => {
  const encoder = new TextEncoder();

  const key = await crypto.subtle.importKey(
    'raw',
    encoder.encode(secret),
    { name: 'HMAC', hash: 'SHA-256' },
    false,
    ['sign'],
  );

  const signature = await crypto.subtle.sign('HMAC', key, encoder.encode(message));

  return Array.from(new Uint8Array(signature))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
};

const GameficationHelper = () => {
  let userData = useSelector(({ userData }) => userData.userData);
  let contactActionSettings = useSelector(({ global }) => global?.contactActionSettings);

  const createContactAction = async (contactAction) => {
    if (!userData) {
      console.warn('!userData');
      return;
    }

    if (!userData.LoyaltyEmail__c) return;

    try {
      let body = contactAction;
      body.actionDate = new Date();
      body.source = 'Portal';
      body.contactEmail = userData.LoyaltyEmail__c;

      const {
        API_SECRET = 'COGNY',
        URL = 'https://contact-action.cognyapi.com',
      } = contactActionSettings || {};

      // Assina exatamente a mesma string que vai no body
      body = JSON.stringify(body);

      const signature = await hmacSha256Hex(body, API_SECRET);

      let response = await fetch(`${URL}/contact_action`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Cogny-Signature-v2': signature,
          'X-Tenant': "CRU",
        },
        body,
      });

      let result = await response.json();
      // console.log(`#>> result`, result)

      return result;
    } catch (e) {
      return 'RETURN ERROR';
    }
    return 'RETURN FIM';
  };

  return { createContactAction };
};

export default GameficationHelper;